import MainArticle from './MainArticle';

export * from './MainArticle.style';
export * from './MainArticle.type';
export default MainArticle;
